import React from 'react';
import { 
  Dialog, 
  DialogContent, 
  DialogHeader, 
  DialogTitle 
} from '@/components/ui/dialog';
import { 
  Building, 
  Bed, 
  Map, 
  Utensils, 
  Bus, 
  ArrowRight
} from 'lucide-react';
import { cn } from '@/lib/utils';

export type ItemType = 'block' | 'accommodation' | 'tour' | 'restaurant' | 'transportation';

interface ItemTypeSelectorProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectType: (type: string) => void;
}

interface ItemTypeOption {
  type: ItemType;
  label: string;
  description: string;
  icon: React.ReactNode;
}

export function ItemTypeSelector({
  isOpen,
  onClose,
  onSelectType
}: ItemTypeSelectorProps) {
  
  const itemTypes: ItemTypeOption[] = [
    {
      type: 'block',
      label: 'Bloco',
      description: 'Blocos de texto e descrições para sua cotação.',
      icon: <Building className="h-8 w-8 text-amber-500" />
    },
    {
      type: 'accommodation',
      label: 'Hospedagem',
      description: 'Hotéis, pousadas, apartamentos e outros tipos de acomodação.',
      icon: <Bed className="h-8 w-8 text-amber-500" />
    },
    {
      type: 'tour',
      label: 'Tour',
      description: 'Passeios, atividades e atrações turísticas.',
      icon: <Map className="h-8 w-8 text-amber-500" />
    },
    {
      type: 'restaurant',
      label: 'Restaurante',
      description: 'Restaurantes, cafés e outros estabelecimentos gastronômicos.',
      icon: <Utensils className="h-8 w-8 text-amber-500" />
    },
    {
      type: 'transportation',
      label: 'Transporte',
      description: 'Transferes, aluguel de carros e outros meios de transporte.',
      icon: <Bus className="h-8 w-8 text-amber-500" />
    }
  ];
  
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[550px]">
        <DialogHeader>
          <DialogTitle className="text-center">
            Escolha o tipo de item para criar
          </DialogTitle>
        </DialogHeader>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 py-4">
          {itemTypes.map((item) => (
            <div 
              key={item.type}
              className="border border-amber-200 rounded-lg overflow-hidden hover:border-amber-300 cursor-pointer transition-all"
              onClick={() => onSelectType(item.type)}
            >
              <div className="flex items-start p-4 hover:bg-amber-50">
                <div className="flex-shrink-0 mt-1 mr-3">
                  {item.icon}
                </div>
                <div className="flex-1">
                  <h3 className="font-medium flex items-center">
                    {item.label}
                    <ArrowRight className="ml-2 h-3 w-3 opacity-50" />
                  </h3>
                  <p className="text-sm text-muted-foreground mt-1">{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
} 